import { render, staticRenderFns } from "./app-project-comp.vue?vue&type=template&id=1643d28e&scoped=true&"
import script from "./js/app-project-comp.js?vue&type=script&lang=js&"
export * from "./js/app-project-comp.js?vue&type=script&lang=js&"
import style0 from "./app-project-comp.vue?vue&type=style&index=0&id=1643d28e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643d28e",
  null
  
)

export default component.exports